import { CreditReportAccountOverview } from "types/landlord/reports";
import { Section } from "views/applications-id-report/components/Section";
import moment from "moment";

const monthsToYearsAndMonths = (months: number) => {
  if (months < 0) return "N/A";
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;
  return `${years} years, ${remainingMonths.toFixed(0)} months`;
};

const CreditStat = ({
  title,
  value,
  secondary
}: {
  title: string;
  value: string;
  secondary?: string;
}) => {
  return (
    <div className="w-[200px]">
      <div className="text-sm text-content-1000">{title}</div>
      <div className="text-base text-content-1000 my-1 font-bold truncate">
        {value}
      </div>
      {secondary && <div className="text-xs text-content-300">{secondary}</div>}
    </div>
  );
};
export const AccountsSummary = ({
  isNoHit,
  accounts
}: {
  accounts?: CreditReportAccountOverview[];
  isNoHit: boolean;
}) => {
  if (isNoHit)
    return (
      <Section sectionTitle="Accounts summary" maxWidth="100%">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  if (!accounts?.length) return null;

  const averageAccountAgeMonths =
    accounts.reduce((acc, account) => {
      if (
        account.date_opened &&
        (account.last_activity_date || account.date_closed)
      )
        // moment diff
        return (acc += moment(
          account.date_closed || account.last_activity_date
        ).diff(moment(account.date_opened), "months", false));

      return acc;
    }, 0) / accounts.length;

  const oldestAccount = accounts.reduce((acc, account) => {
    if (moment(account.date_opened).isBefore(acc.date_opened)) return account;

    return acc;
  }, accounts[0]);

  const mostRecentAccount = accounts.reduce((acc, account) => {
    if (moment(account.date_opened).isAfter(acc.date_opened)) return account;

    return acc;
  }, accounts[0]);

  return (
    <Section sectionTitle="Accounts summary" maxWidth="100%">
      {/* Eric asked me not to calculate that */}
      {/* <Stat title="Length of Credit History" /> */}

      <div className="flex gap-x-4 gap-y-8 flex-wrap">
        <CreditStat
          title="Average Account Age"
          value={monthsToYearsAndMonths(averageAccountAgeMonths)}
        />

        <CreditStat
          title="Oldest Account"
          value={oldestAccount.account_name || ""}
          secondary={moment(oldestAccount.date_opened).format("MMM DD, YYYY")}
        />

        <CreditStat
          title="Most Recent Account"
          value={mostRecentAccount.account_name || ""}
          secondary={moment(mostRecentAccount.date_opened).format(
            "MMM DD, YYYY"
          )}
        />

        <CreditStat
          title="Number of accounts"
          value={String(accounts.length)}
        />

        <CreditStat
          title="Revolving"
          value={
            String(
              accounts.filter((account) => account.portfolio_type?.code === "R")
                .length
            ) || "--"
          }
        />

        <CreditStat
          title="Installments"
          value={
            String(
              accounts.filter((account) => account.portfolio_type?.code === "I")
                .length
            ) || "--"
          }
        />

        <CreditStat
          title="Mortgage"
          value={
            String(
              accounts.filter((account) => account.portfolio_type?.code === "M")
                .length
            ) || "--"
          }
        />

        {/* Haven't seen it yet */}
        {/* <CreditStat title="Line of Credit" /> */}

        <CreditStat
          title="Other"
          value={
            String(
              accounts.filter(
                (account) =>
                  !["R", "I", "M"].includes(account.portfolio_type?.code || "")
              ).length
            ) || "--"
          }
        />
      </div>
    </Section>
  );
};
